module.exports = __webpack_public_path__ + "img/motion-path.13557a92.svg";